import { Fuel, TopupHistoryItem } from '@/src/api/payg/types';
import { PageWithNavigationAndSectionPadding } from '@/src/components';
import { PAYG_EVENTS } from '@/src/constants/analytics';
import { ROUTE_PAYG_TOPUP_HISTORY } from '@/src/constants/routes';
import AnalyticsService from '@/src/services/analyticsService';
import { Icon, Stack } from '@ovotech/element-v5';
import { Card as NebulaCard } from '@ovotech/nebula';
import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom-v5';
import { TopupDetailContent } from './components/TopupDetailContent';
import { TopupDetailHeader } from './components/TopupDetailHeader';
import { BackLink } from './PAYGTopupDetailPage.styled';

type DetailLocationState = {
  topup?: TopupHistoryItem;
  fuel?: Fuel;
};

export const PAYGTopupDetailPage = () => {
  const { state } = useLocation<DetailLocationState | undefined>();

  useEffect(() => {
    if (state?.topup && state?.fuel) {
      AnalyticsService.dispatch(
        ...PAYG_EVENTS.topupDetailViewed({
          fuel: state.fuel,
          ...state.topup,
        }),
      );
    }
  }, [state?.topup, state?.fuel]);

  if (!state?.topup || !state?.fuel) {
    return <Redirect to={ROUTE_PAYG_TOPUP_HISTORY} />;
  }

  const { topup, fuel } = state;

  return (
    <PageWithNavigationAndSectionPadding title="Top-up details">
      <NebulaCard>
        <Stack spaceBetween={6}>
          <BackLink to={ROUTE_PAYG_TOPUP_HISTORY}>
            <Icon name="chevron-left-small" size={20} />
            Back to top-up history
          </BackLink>
          <TopupDetailHeader item={topup} fuel={fuel} />
          <TopupDetailContent item={topup} />
        </Stack>
      </NebulaCard>
    </PageWithNavigationAndSectionPadding>
  );
};
